import { Input, Button, Space, Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import _ from 'lodash';
const subscription_period = [
  '',
  'Monthly',
  '',
  'Quarterly',
  '',
  '',
  'Bi Annually',
  '',
  '',
  '',
  '',
  '',
  'Annually',
];

export const SubscriptionTableConfig = (handleSearch, handleReset, responsibilities) => {
  const getColumnSearchProps = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
                backgroundColor: '#32d193',
                borderColor: '#32d193',
                color: 'white',
              }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
    };
  };
  return [
    {
      title: 'Client ID',
      dataIndex: 'client_id',
      key: 'client_id',
      width: '5%',
    },

    {
      title: 'Client Name',
      dataIndex: 'client_name',
      key: 'client_name',
      width: '5%',
      ...getColumnSearchProps('client_name'),
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
      width: '5%',
      ...getColumnSearchProps('last_name'),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '5%',
      ...getColumnSearchProps('email'),
    },
    {
      title: 'Product Name',
      dataIndex: 'productname',
      key: 'productname',
      width: '5%',
      ...getColumnSearchProps('productname'),
    },
    {
      title: 'Subscribe Date',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '5%',
      render: (created_at) => {
        return <div>{created_at ? created_at.split('T')[0] : 'N/A'}</div>;
      },
    },
    {
      title: 'Subscribtion Period',
      dataIndex: 'subscriptionperiod',
      key: 'subscriptionperiod',
      width: '5%',
      render: (subscriptionperiod) => subscription_period[parseInt(subscriptionperiod)],
    },

    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      width: '3%',
      render: (status) => {
        return <Tag color={status ? 'green' : 'red'}>{status ? 'Active' : 'In Active'}</Tag>;
      },
    },
  ];
};
